module.exports = __webpack_public_path__ + "bd4e04e6de5bdfe6a53faa8a171abf99.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/swimsuit-red-stripe.png
// module id = 2014
// module chunks = 0